import React, { useState } from 'react';
import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Popover,
  Select,
  Switch,
} from 'antd';
import {
  createMarketHours,
  createPreset,
  createUnderlyingAsset,
  instrumentTypes,
  marketHours,
  REGIONS,
  selectors,
  UnderlyingAsset,
  updatePresetName,
} from 'state';
import { useDispatch, useSelector } from 'react-redux';
import { InfoCircleOutlined } from '@ant-design/icons';
import { auctions_tenors } from '../../../state/app/auctions/types';
import {
  CDS_FREQUECIES,
  TENOR_UNITS,
} from '../../../state/app/repos/constants';

type Props = {
  hide: () => void;
  visible: boolean;
  preset_name: string;
  preset_id: number;
};
const EditPresetNameModal: React.FC<Props> = ({
  hide,
  visible,
  preset_name,
  preset_id,
}) => {
  const dispatch = useDispatch();
  const [presetName, setPresetName] = useState('');

  return (
    <Modal
      open={true}
      onOk={hide}
      onCancel={hide}
      title={`Edit name of preset: ${preset_name}`}
      width={450}
      footer={null}
    >
      <div
        style={{
          textAlign: 'right',
        }}
      >
        <Input
          value={presetName}
          onChange={e => {
            setPresetName(e.target.value);
          }}
          placeholder="New Name"
        />
        <Button
          style={{ marginTop: 15 }}
          type="primary"
          disabled={!presetName}
          onClick={() => {
            dispatch(
              updatePresetName({
                new_preset_name: presetName,
                preset_id: preset_id,
              })
            );
            hide();
          }}
        >
          Update Name
        </Button>
      </div>
    </Modal>
  );
};
export default EditPresetNameModal;
